import React from "react"
import cx from "classnames"
import styles from "./styles.scss"

export const TYPES = {
  PRIMARY: "primary",
  SUCCESS: "success",
  DARK_GRAY: "darkgray",
  LOADING: "loading",
}

export const SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  X_LARGE: "xlarge",
}

export const Button = ({
  children,
  onClick,
  type,
  disabled,
  buttonType,
  buttonSize,
}) => (
  <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    className={cx(
      styles.button,
      styles[buttonType || TYPES.PRIMARY],
      styles[buttonSize || SIZES.MEDIUM]
    )}
  >
    {children}
  </button>
)



// WEBPACK FOOTER //
// src/components/Button/index.jsx